import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  width: 100%;
  flex-wrap: wrap;

  .ant-select-selector {
    width: 200px;
  }
`;
